import React,{useState,useEffect} from 'react';
import { Col, Container, Row, Card,CardBody, Modal,ModalHeader,ModalBody,ModalFooter } from 'reactstrap';
import { Button, Form } from 'react-bootstrap';
import { useHistory,useParams } from 'react-router-dom';
import {toLower} from 'lodash';
import axios,{post,get,patch} from 'axios';
import StatusSteps from '../../../Helper/StatusSteps';
import { ToastContainer, toast } from 'react-toastify';
import config from '../../../../config';
import Loader from '../../../Helper/Loader'
import empty from 'is-empty'
import CustomSwitch from "../../../Helper/CustomSwitch";
import OTPInput, { ResendOTP } from "otp-input-react";
import moment from 'moment';
import Select from 'react-select'
import Breadcrumbs from '../../../Helper/Breadcrumbs'
import ErrorHandling from '../../../Helper/ErrorHandling';
import TextField from '@mui/material/TextField';	
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';	
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';	
import { DatePicker } from '@mui/x-date-pickers/DatePicker';	
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

const BookingForm = (props) => {
  let history = useHistory();
  let {vendorId, bookingId} = useParams();
  let tokenKey = {headers:{Authorization:'Token '+sessionStorage.getItem('tokenKey')}};
  let propsState = props.history.location.state;
  const [form, setForm] = useState({});
  const [payDetails, setPayDetails] = useState({});
  const [editMode, setEditMode] = useState(propsState && propsState.editMode || false);
  const [errors, setErrors] = useState({});
  const [payErrors, setPayErrors] = useState({});
  const [showModal, setShowModal] = useState(false) 
  const [OTP, setOTP] = useState("");
  const [otpVerified, setOTPVerified] = useState(false)
  const [loading, setloading] = useState(true);
  const [overlay, setoverlay] = useState(false);
  const [stateList, setstateList] = useState([]);
  const [state, setstate] = useState(null);
  const [mandapList, setmandapList] = useState([]);
  const [mandap, setmandap] = useState(null);
  const [vendorList, setvendorList] = useState([]);
  const [vendor, setvendor] = useState(null);
  const [showPayModal, setshowPayModal] = useState(false);
  const [areaList, setareaList] = useState([]);
  const [area, setarea] = useState(null);
  const [funcTypeList, setfuncTypeList] = useState([]);
  const [funcType, setfuncType] = useState(null);
  const [formId, setformId] = useState(bookingId ? bookingId : propsState && propsState.id);
  const [handleErr, sethandleErr] = useState(false);
  const [errData, seterrData] = useState(null);
  const [bookingType, setbookingType] = useState(null);
  const [startTime, setstartTime] = useState(null);
  const [endTime, setendTime] = useState(null);


  let breadcrumbData =  [
    {
      title : 'Bookings',
      href : '/booking'
    },{
      title : editMode || bookingId ? 'View' :  'Create',
      href : '#'
    }
  ]
  let isAdminUser = sessionStorage.getItem('permission') ? JSON.parse(sessionStorage.getItem('permission'))[0].user_role === 'admin' || false : false;
  let toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    };
    const bookingTypes = [{value:'full_day', label:'Full day'},{value:'half_day_morning', label:'Half a day - Morning'},{value:'half_day_evening', label:'Half a day - Evening'},{value:'custom', label:'Custom'}];

  const [tab, setTab] = useState({
      details:true,
  });
    const [tabData, setTabData] = useState([
        {
            name:'Details',
            id:'details',
            show:true
        }
    ]);

    const toggleModal = () => {
        setShowModal(!showModal);
        setOTP('')
    }

    const handleModalClose = () => {
        setshowPayModal(false)
    }

    const handlePayInput = (keyName,value) => {
        setPayDetails({
            ...payDetails,
            [keyName] : value
        })
        if (keyName && !!payErrors[keyName]) setPayErrors({
            ...payErrors,
            [keyName]: null
          })
    }

    const handleInput = (keyName,value) => {
        setForm({
            ...form,
            [keyName] : value
        })
        if (keyName && !!errors[keyName]) setErrors({
            ...errors,
            [keyName]: null
          })
    }
    const handleSelect = (keyName,setFn,e) =>{
        setFn(e);
        setForm({
            ...form,
            [keyName] : e && e.value || null
        })
        if (keyName && !!errors[keyName]) setErrors({
            ...errors,
            [keyName]: null
          })
    }
    useEffect(() => {
        handleBookingDate(form.booking_date)
    }, [form.mandap_id,form.mandap_function_type]);

    const handleBookingDate = newValue => {
        if(newValue){
            setLoader(true)
            let data = {
                mandap_id : form.mandap_id,
                muhurtham_date : moment(newValue).format('YYYY-MM-DD')
            }
            post(config.service+'/masters/check-muhurtham-date/',data,tokenKey).then(res=>{
                setForm({...form,booking_date : newValue});
                handleBookingType(bookingType, newValue)
                setErrors({
                    ...errors,
                    booking_date: null
                    })
                setLoader(false)
            }).catch(err=>{
                if(err.response.status === 401) window.location.href = '/';
                else{
                    get(config.service+'/masters/mandap-functiontype-pricing/'+form.mandap_id+'/',tokenKey).then(res=>{
                        let isValueSet = false;
                        res.data.map(obj=>{
                            if(obj.function_type === form.mandap_function_type){
                                setForm({
                                    ...form,
                                    amount : obj.price,
                                    booking_date : newValue
                                })
                                isValueSet = true;
                            }
                        })
                        if(!isValueSet) setForm({...form,booking_date : newValue});
                        setErrors({
                            ...errors,
                            booking_date: null
                            })
                        setLoader(false)
                    })
                }
            })
        }
    }
    const handleBookingType = (e, bookingDate) => {
        setLoader(true);
        if(form.mandap_id && form.mandap_function_type)
            get(config.service+'/masters/mandap_pricing/list/?&mandap_id='+form.mandap_id,tokenKey).then(res=>{
                if(empty(res.data)){
                    setbookingType(e);
                    setForm({
                        ...form,
                        booking_from : null,
                        booking_to : null,
                        timing : e && e.value || null,
                        amount: '',
                        reservation_price : '',
                        booking_date : bookingDate ? bookingDate : form.booking_date
                    })
                } else{
                    let pricing = res.data[0], totalAmount = '', startTime = null, endTime = null;
                    if(e && e.value === 'full_day') {
                        totalAmount = pricing.fd_price;
                        startTime = pricing.fd_start_time;
                        endTime = pricing.fd_end_time;
                    }
                    else if(e && e.value === 'half_day_morning') {
                        totalAmount = pricing.hf_am_price;
                        startTime = pricing.hf_am_start_time;
                        endTime = pricing.hf_am_end_time;
                    }
                    else if(e && e.value === 'half_day_evening') {
                        totalAmount = pricing.hf_pm_price;
                        startTime = pricing.hf_pm_start_time;
                        endTime = pricing.hf_pm_end_time;
                    }
                    const d = moment(new Date()).format('L');
                    let startTimeVal = moment(d +' '+ startTime).format();
                    let endTimeVal = moment(d +' '+ endTime).format();

                    setbookingType(e);
                    setForm({
                        ...form,
                        booking_from : null,
                        booking_to : null,
                        timing : e && e.value || null,
                        start_time : startTime,
                        end_time : endTime,
                        amount: totalAmount ? totalAmount : '',
                        reservation_price : e && e.value === 'custom' ? '' : e && e.value ? pricing.reservation_price : '',
                        booking_date : bookingDate ? bookingDate : form.booking_date
                    })
                    setstartTime(startTimeVal)
                    setendTime(endTimeVal)
                    if (!!errors['amount'] && !empty(totalAmount)) setErrors({
                        ...errors,
                        amount: null
                    })
                }
            if (!!errors['timing']) setErrors({
                ...errors,
                timing: null
            })
            setLoader(false);
          }).catch(err=>{ 
            setLoader(false);
            if(err.response.status === 401) window.location.href = '/';
        })
        else {
            toast.error('Select a Mandap Name and Function Type to get booking price details', toastAttr);
            setLoader(false);
        }
    }

    const onChangeTime = (value, keyName, setFn) => {
        let val = moment(value).format('HH:mm:ss')
        setFn(value)
        setForm({
            ...form,
            [keyName] : val
        })
    }


    const handleCheckBox = (keyName,value) => {
        setForm({
            ...form,
            [keyName] : value
        })
        if (keyName && !!errors[keyName]) setErrors({
            ...errors,
            [keyName]: null
          })
    }
    const handlePayCheckBox = (keyName,value) => {
        setPayDetails({
            ...payDetails,
            [keyName] : value
        })
    }

    const handleDate = (keyName,value) => {
        setForm({
            ...form,
            [keyName] : value
        })
        if (keyName && !!errors[keyName]) setErrors({
            ...errors,
            [keyName]: null
          })
    }

  const renderListView = () => {
      history.push('/booking')
  }

  const findErrors = () => {
    const { customer_name,mobile,address_line_1,area, state_id,pincode,mandap_function_type,amount,timing, mandap_id, vendor_id, reservation_price, booking_from, booking_to, booking_date } = form
    const newErrors = {}
    if ( empty(customer_name) ) newErrors.customer_name = 'This is a required field';
    if ( empty(mobile) ) newErrors.mobile = 'This is a required field';
    if ( empty(address_line_1) ) newErrors.address_line_1 = 'This is a required field';
    if ( empty(area) ) newErrors.area = 'This is a required field';
    if ( empty(state_id) ) newErrors.state_id = 'This is a required field';
    if ( empty(pincode) ) newErrors.pincode = 'This is a required field';
    if ( empty(mandap_id) ) newErrors.mandap_id = 'This is a required field';
    if ( empty(mandap_function_type) ) newErrors.mandap_function_type = 'This is a required field';
    if ( empty(amount) ) newErrors.amount = 'This is a required field';
    if ( empty(timing) ) newErrors.timing = 'This is a required field';
    // if ( empty(vendor_id) ) newErrors.vendor_id = 'This is a required field';
    if ( empty(reservation_price) ) newErrors.reservation_price = 'This is a required field';
    if(bookingType && bookingType.value === 'custom' && empty(booking_from)) newErrors.booking_from = 'This is a required field';
    if(bookingType && bookingType.value === 'custom' && empty(booking_to)) newErrors.booking_to = 'This is a required field';
    if(bookingType && bookingType.value !== 'custom' && empty(booking_date)) newErrors.booking_date = 'This is a required field';

    return newErrors;
   }

  const saveForm = () => {
    let id =editMode ? formId : null, method = editMode ? 'put' : 'post';
    const newErrors = findErrors();
    if ( Object.keys(newErrors).length > 0 ) {
      setErrors(newErrors)
      toast.error('Enter all required details to proceed', toastAttr);
    } else {
      setLoader(true);
        let url = editMode ? config.service+'/booking/update/' : config.service+'/booking/create/', data=JSON.parse(JSON.stringify(form));
        if(data.timing === 'custom'){
            if(data.booking_from) data.booking_from = moment(form.booking_from).format('YYYY-MM-DD HH:mm:ss');
            if(data.booking_to) data.booking_to = moment(form.booking_to).format('YYYY-MM-DD HH:mm:ss');
        } else {
            delete data['booking_from'];
            delete data['booking_to'];
        }
        if(data.booking_date) data.booking_date = data.booking_date.split('T')[0]
        data.vendor_id = vendorId ? vendorId : JSON.parse(sessionStorage.getItem('permission'))[0].vendor_ids[0]
        if(editMode) data.booking_id = data.id;
        else data.otp_confirmation = otpVerified;
        
        axios({
            url: url,
            method: method,
            headers: {Authorization:'Token '+sessionStorage.getItem('tokenKey')},
            data: data,
          }).then(res=>{
            if(res.data.booking_from && res.data.booking_to){
              let fromDate = res.data.booking_from.replace('T',' ').replace('Z',''),toDate = res.data.booking_to.replace('T',' ').replace('Z','')
            res.data.booking_from = new Date(fromDate)
            res.data.booking_to = new Date(toDate)
            }
            res.data.vendor_id = res.data.vendor;
              setForm(res.data);
              setEditMode(true);
              toast.success('Saved successfully', toastAttr);
              window.scrollTo(0, 0)
              setLoader(false);
        }).catch(err=>{
          if(err.response.status === 401) window.location.href = '/'
          else 
          {seterrData(err.response && err.response.data); sethandleErr(true);}
          toast.error('Saving Failed', toastAttr);
            setLoader(false);
        })
    }
  }

  const closeErrorHandling = () => {
    sethandleErr(false)
    seterrData(null);
  }

  const getApprovalBtnValue = () => {
    let status = form.status, val = '',
        statusMap = {
            draft : 'Confirm Booking',
            blocked : 'Confirm Booking',
            // booking_confirmed : 'Issue Voucher',
            // voucher_issued : 'Redeem Voucher',
            voucher_redeemed : 'Encash',
        };
        if(!isAdminUser && (statusMap[status] !=='Confirm Booking'))  // include enquiry,quotation status
          return false;
        else 
        return statusMap[status];
  }

  const triggerApproval = (btnName) => {
    const newErrors = findErrors();
    if ( Object.keys(newErrors).length > 0 ) {
      setErrors(newErrors);
      toast.error('Enter all required details to proceed', toastAttr);
    } else {
        let mapStatus = {
            'Confirm Booking' : 'booking_confirmed',
            'Issue Voucher' : 'voucher_issued',
            'Redeem Voucher' : 'voucher_redeemed',
            'Encash' : 'encash',
            'cancel' : 'cancelled'
        }
      let data = {
        status : mapStatus[btnName],
        booking_id : form.id 
      }
      setLoader(true);
      patch(config.service+'/booking/update/',data,tokenKey).then(res=>{
        toast.success('Action perfomed successfully', toastAttr);
        get(config.service+'/booking/'+form.id,tokenKey).then(res=>{
            if(res.data.booking_from && res.data.booking_to){
                let fromDate = res.data.booking_from.replace('T',' ').replace('Z',''),toDate = res.data.booking_to.replace('T',' ').replace('Z','')
                res.data.booking_from = new Date(fromDate)
                res.data.booking_to = new Date(toDate)
            }
            res.data.vendor_id = res.data.vendor;
            setForm(res.data);
            setLoader(false);
          })
      }).catch(err=>{
        if(err.response.status === 401) window.location.href = '/'
        if(err.response && err.response.data && err.response.data.message) 
            toast.error(err.response.data.message, toastAttr);
        else toast.error('Action failed', toastAttr);
        setLoader(false);
      });
    }
  }

  const setLoader = (val) => {
    setloading(val);setoverlay(val);
  }

  const genOTP = () => {
    if(form.mobile){
        let data = {
            mobile : form.mobile,
            user_type : 'customer'
        }
      post(config.service+'/sms/generateOtp/',data,tokenKey).then(res=>{
          setShowModal(true);
        }).catch(err=>{
          if(err.response.status === 401) window.location.href = '/'
          toast.error('OTP generation failed', toastAttr);
        });
    } else toast.error('Enter mobile number to receive OTP', toastAttr);

  }

  const verifyOTP = () => {
    let data = {
        mobile : form.mobile,
        user_type : 'customer',
        otp:OTP,
    }
    post(config.service+'/sms/verifyOtp/',data,tokenKey).then(res=>{
        toast.success('OTP verified successfully', toastAttr);
        toggleModal();
        setOTPVerified(true);
      }).catch(err=>{
        if(err.response.status === 401) window.location.href = '/'
        toast.error('OTP verification failed', toastAttr);
      });
  }

const renderButton = (buttonProps) => {
    return <button className='btn btn-primary' {...buttonProps}>Resend OTP</button>;
};
const renderTime = (remainingTime) => {
    return <span>{remainingTime} seconds remaining</span>;
};

  useEffect(() => {
    if(bookingId) setEditMode(true);
    get(config.service+'/booking/getBookingMasters/',tokenKey).then(res=>{
        let state = [], mandap=[],vendor=[], area=[], funcType=[],data=res.data;
        for(let i in data.state) state.push({label:data.state[i].name,value:data.state[i].id})
        for(let i in data.mandap) mandap.push({label:data.mandap[i].mandap_name,value:data.mandap[i].id})
        for(let i in data.vendor) vendor.push({label:data.vendor[i].vendor_name,value:data.vendor[i].id})
        for(let i in data.area) area.push({label:data.area[i].name,value:data.area[i].id})
        for(let i in data.function_type) funcType.push({label:data.function_type[i].function_type,value:data.function_type[i].id})

      setstateList(state); setmandapList(mandap); setvendorList(vendor); setareaList(area); setfuncTypeList(funcType);
    
    if((propsState && propsState.editMode)|| bookingId)
        get(config.service+'/booking/'+formId,tokenKey).then(res=>{
            if(res.data.booking_from && res.data.booking_to){
                let fromDate = res.data.booking_from.replace('T',' ').replace('Z',''),toDate = res.data.booking_to.replace('T',' ').replace('Z','')
                res.data.booking_from = new Date(fromDate)
                res.data.booking_to = new Date(toDate)
            }
            let val = state.filter(temp=>temp.value === res.data.state_id);
            let mandapVal = mandap.filter(temp=>temp.value === res.data.mandap_id);
            let vendorVal = vendor.filter(temp=>temp.value === res.data.vendor_id);
            let areaVal = area.filter(temp=>temp.value === res.data.area);
            let funcTypeVal = funcType.filter(temp=>temp.value === res.data.mandap_function_type);
            let timingVal = bookingTypes.filter(temp=>temp.value === res.data.timing);
            res.data.vendor_id = res.data.vendor;
            const d = moment(new Date()).format('L');
            let startTimeVal = moment(d +' '+ res.data.start_time).format();
            let endTimeVal = moment(d +' '+ res.data.end_time).format();
            // res.data.booking_date = res.data.booking_date+'T00:00:00.000Z"'
            setstartTime(startTimeVal)
            setendTime(endTimeVal)
            setstate(val[0]); setmandap(mandapVal[0]); setvendor(vendorVal[0]); setarea(areaVal); setfuncType(funcTypeVal);
            setbookingType(timingVal[0])
            setForm(res.data);
            setLoader(false); 
          }).catch(err=>{setLoader(false);toast.error('Retrieval Failed', toastAttr);})
        else {
        setLoader(false); 
        }
        }).catch(err=>{
        if(err.response.status === 401) {
            let url = document.URL.split('/vendorportal')[1]
            if(vendorId) sessionStorage.setItem('redirectURL',url);
            window.location.href = '/vendorportal'}
        });
  }, []);

//   useEffect(() => {
//     const script = document.createElement('script');
  
//     script.src = "https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.esm.js";
//     script.async = true;
//     script.type= 'module';

//     const script1 = document.createElement('script');
  
//     script1.src = "https://uat.billdesk.com/jssdk/v1/dist/billdesksdk.js";
//     script1.async = true;
//     script1.noModule= true;

//     const link = document.createElement('link');
  
//     link.href = "https://uat.billdesk.com/jssdk/v1/dist/billdesksdk/billdesksdk.css";
//     link.rel= 'stylesheet';
  
//     document.body.appendChild(script);
//     document.body.appendChild(script1);
//     document.body.appendChild(link);

  
//     return () => {
//       document.body.removeChild(script);
//       document.body.removeChild(script1);
//       document.body.removeChild(link);

//     }
//   }, []);


  const triggerPaymentPortal = () => {
	
	var flow_config = {
		merchantId: "BDUATV2TND",
		bdOrderId: "OAEW19XTKTVYWY",
		authToken: "OToken 6BB2AA014713604089B39E2EED0094B702245BAB450E0C6A34440CD3AB8C8380EE8B8A953548E9FA8793E1338960BB27C9847F930407136C4E1D1703BD6CA905E8ECD639C8BD15E94A608A610A2FE5112B67CF9DD1FB0E3951EDFB7E8A19A3AA0D2A07365F9DBAA78BF5D0D8EBDA3183F1B507599E5F6C6B6326A399B6F94F3D9E89B91361314E578B1ED7BFFDD50369B329FDFF0E8981BD8D63F3.4145535F55415431",
		childWindow: true,
		returnUrl: "https://www.billdesk.com/"
};	
	var config = {
		merchantLogo: "data:image/png;base64,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",
		flowConfig: flow_config,
		flowType: "payments"
	};

		document.getElementById("result").innerHTML = "";
		var xmlhttp = new XMLHttpRequest();
		var jsonObj = "";
		window.loadBillDeskSdk(config);
  }

  const showPayDetailsModal = () => {
      setPayDetails({
          mobile : form.mobile,
          email:form.email,
      })
    setshowPayModal(true);
  }


  const proceedToPayment = () => {
    const { mobile,amountToPay } = payDetails
    const newErrors = {}
    if ( empty(mobile) ) newErrors.mobile = 'This is a required field';
    if ( empty(amountToPay) ) newErrors.amountToPay = 'This is a required field';
    if ( Object.keys(newErrors).length > 0 ) {
        setPayErrors(newErrors)
        toast.error('Enter the required details to proceed', toastAttr);
      } else if(amountToPay > form.amount){
        toast.error('Entered amount is more than the total amount. Kindly change', toastAttr);
      }
      else {
    setLoader(true);
    let data = {
        mobile : payDetails.mobile,
        email : payDetails.email,
        advance : true,
        amount : payDetails.amountToPay,
        alternate_mobile : false,
        customer_id : form.customer_id,
        booking_id :  form.id
    }
    post(config.service+'/booking/paymentlink/create/',data,tokenKey).then(res=>{
        // sessionStorage.setItem('bookingPayDetails', res.data);
        setshowPayModal(false);
        setLoader(false);
        toast.success('Payment link is sent to the given mobile number / email', toastAttr);
      }).catch(err=>{
        if(err.response.status === 401) window.location.href = '/'
        toast.error('Payment link generation failed', toastAttr);
        setLoader(false);
        setshowPayModal(false);
  });
}
  }

  const onChangeDateTime = (value, keyName) => {	
    let val = moment(value).format('YYYY-MM-DD HH:mm:ss')	
    setForm({	
        ...form,	
        [keyName] : val	
    })	
    setErrors({	
        ...errors,	
        [keyName]: null	
      })
}
  const redirectTo = (path,keyName) => {
    let mandapName = mandap ? mandap.label : 'details'
    history.push({
        pathname: path,
        state : {
            bookingId : form.id,
            breadcrumbData : [{
                title : 'Bookings',
                href : '/booking'
              },{
                title : 'Booking - '+mandapName,
                href : '/bookingForm/'+form.id
              },{
                title : 'View '+keyName,
                href : '#'
              }]
        }
    })
}


  let approvalBtn = getApprovalBtnValue();
  return (
  <Container className="vendor">
    <Row>
  <Col md={12} className='contBody'>
    <Card>
      <CardBody className='theme-light'>
        <div className="card__title pageNav">
          <div className="bold-text">
          <Breadcrumbs data={breadcrumbData} />
          </div>
        </div>
        <Row className='formBtnsDiv'>
            <Col md={7}>
                    <Button variant='primary' onClick={e=>{saveForm()}}>Save</Button> 
                    <Button variant='secondary' onClick={e=>{renderListView()}}>Cancel</Button>
                    {!editMode ? <Button variant='primary' onClick={e=>genOTP()}>Generate OTP</Button> : ''}
            </Col>
            {editMode ? 
            <Col md={5} className='navigations'>
                {form.status === 'booking_confirmed' ? <div className='softButton' title='View Cashback' onClick={()=>redirectTo('/cashback','Cashback')}><span>CASHBACK</span></div> : ''}
                <div className='softButton' title='View Payments' onClick={()=>redirectTo('/ViewPayment','Payment')}><span>PAYMENTS</span></div>            </Col> : ''}
        </Row>
        <Row className='formBtnsDiv'>
            <Col md={12} style={{margin:'5px 0'}}>
    {editMode && approvalBtn ? <Button variant='primary' onClick={e=>{triggerApproval(approvalBtn)}}>{approvalBtn}</Button>  : ''}
    {editMode ? <><Button variant='primary' onClick={e=>{showPayDetailsModal()}}>Proceed to Payment</Button></> : ''}
    {editMode && (form.status && form.status !== 'cancelled') ?<Button variant='secondary' onClick={e=>{triggerApproval('cancel')}}>Cancel Booking</Button> : ''}

    {/* && form && form.status === 'quotation' */}
    {editMode ? <StatusSteps data={{status: form.status}}  />  : ''}
            </Col>
        </Row>
        <Row className='formDiv'>
            <Col md={12}>
                <nav>
                    <div className='nav nav-tabs' id='nav-tab' role='tablist'>
                        <div className='tabList'>
                            {tabData.map((tab,index)=>{
                                let disCls = tab.disable;
                                return tab.show ? (
                                    <a className={`nav-item nav-link active`} 
                                    id={tab.id} name={index} data-toggle='tab' role='tab' aria-controls='nav-details' aria-selected='true'>
                                        {tab.name}
                                    </a>
                                ) : '';
                            })}
                        </div>
                    </div>
                </nav>
                <div className='tabContent'>
                    <Form className="form defaultForm" >
                    <Loader loading={loading} overlay={overlay}>
                        {tab.details ? 
                        <Row><Col md={12}>
                            <fieldset className="border p-2 fieldsetCls">
                                <legend className="w-auto">Booking Details</legend>
                                    <Row>
                                        <Col md={6}>
                                        {editMode ? <Row>
                                                <Col md={4}>
                                                    <Form.Label>Booking Ref. Number</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control disabled className='bookingNum' type='text' name="booking_no" value={form.booking_no}  />
                                                </Col>
                                            </Row> : ''}
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Mandap Name</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Select className={`selectBox ${!! errors.mandap_id ? 'inValidField' : ''}`}
                                                        value={mandap}
                                                        onChange={e=>handleSelect('mandap_id',setmandap,e)}
                                                        options={mandapList}
                                                        isClearable 
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Function Type</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Select className={`selectBox ${!! errors.mandap_function_type ? 'inValidField' : ''}`}
                                                        value={funcType}
                                                        onChange={e=>handleSelect('mandap_function_type',setfuncType,e)}
                                                        options={funcTypeList}
                                                        isClearable 
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Total Amount</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='number' name="amount" value={form.amount} onChange={e=> handleInput('amount',e.target.value)} isInvalid={!! errors.amount} />
                                                <Form.Control.Feedback type='invalid'>
                                                    { errors.amount }
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                            {/* <Row>
                                                <Col md={4}>
                                                    <Form.Label>Booking From</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                    <DateTimePicker required minDate={new Date()} 
                                                     name="booking_from" value={form.booking_from} onChange={val => {handleDate('booking_from',val)}} />
                                                <Form.Control.Feedback type='invalid'>
                                                    { errors.booking_from }
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Booking To</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <DateTimePicker required minDate={form.booking_from}
                                                 name="booking_to" value={form.booking_to} onChange={val => {handleDate('booking_to',val)}} />
                                                <Form.Control.Feedback type='invalid'>
                                                    { errors.booking_to }
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Row> */}
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Booking Type</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                    <Select className={`selectBox ${!! errors.timing  ? 'inValidField' : ''}`}
                                                        value={bookingType}
                                                        onChange={e=>handleBookingType(e)}
                                                        options={bookingTypes}
                                                        isClearable
                                                    />
                                                    {errors.timing ? 
                                                    <Form.Control.Feedback type='invalid' className='d-block'>
                                                        { errors.timing }
                                                    </Form.Control.Feedback> : ''}
                                                </Col>
                                            </Row>
                                            {bookingType && bookingType.value !== 'custom' ?
                                                <>
                                                    <Row>
                                                        <Col md={4}>
                                                            <Form.Label>Booking Date</Form.Label>
                                                        </Col>
                                                        <Col md={7} className="datePicker">
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <DatePicker inputFormat='dd-MM-yyyy'
                                                                    label=""
                                                                    value={form.booking_date || null}
                                                                    onChange={(newValue) => handleBookingDate(newValue)}
                                                                    renderInput={(params) => <TextField  className='form-control' {...params} />}
                                                                />
                                                                {errors.booking_date ? 
                                                                    <Form.Control.Feedback type='invalid' className='d-block'>
                                                                        { errors.booking_date }
                                                                    </Form.Control.Feedback> : ''}
                                                            </LocalizationProvider>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={4}>
                                                            <label> Start Time</label>
                                                        </Col>
                                                        <Col md={7} className="timePicker">
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <TimePicker 
                                                                    value={startTime}
                                                                    onChange={(newValue) => {
                                                                    onChangeTime(newValue,'start_time',setstartTime)
                                                            }}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            />
                                                            </LocalizationProvider>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md={4}>
                                                            <label> End Time</label>
                                                        </Col>
                                                        <Col md={7} className="timePicker">
                                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                                <TimePicker 
                                                                    value={endTime}
                                                                    onChange={(newValue) => {
                                                                    onChangeTime(newValue,'end_time',setendTime)
                                                            }}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            />
                                                            </LocalizationProvider>
                                                        </Col>
                                                    </Row>
                                                </> : bookingType && bookingType.value === 'custom' ?
                                                 <>
                                                 <Row>
                                                     <Col md={4}>
                                                         <Form.Label>Booking From</Form.Label>
                                                     </Col>
                                                     <Col md={7} className="dateTimePicker">
                                                         <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                             <DateTimePicker
                                                                 label=""
                                                                 value={form.booking_from || null}
                                                                 onChange={(newValue) => onChangeDateTime(newValue,'booking_from')}
                                                                 renderInput={(params) => <TextField  className='form-control' {...params} />}
                                                             />
                                                             {errors.booking_from ? 
                                                                    <Form.Control.Feedback type='invalid' className='d-block'>
                                                                        { errors.booking_from }
                                                                    </Form.Control.Feedback> : ''}
                                                         </LocalizationProvider>
                                                     </Col>
                                                 </Row>
                                                 <Row>
                                                     <Col md={4}>
                                                         <Form.Label>Booking To</Form.Label>
                                                     </Col>
                                                     <Col md={7} className="dateTimePicker">
                                                         <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                             <DateTimePicker
                                                                 label=""
                                                                 value={form.booking_to || null}
                                                                 onChange={(newValue) => onChangeDateTime(newValue,'booking_to')}
                                                                 renderInput={(params) => <TextField className='form-control' {...params} />}
                                                             />
                                                             {errors.booking_to ? 
                                                                    <Form.Control.Feedback type='invalid' className='d-block'>
                                                                        { errors.booking_to }
                                                                    </Form.Control.Feedback> : ''}
                                                         </LocalizationProvider>
                                                     </Col>
                                                 </Row>
                                             </>  : '' }
                                             <Row>
                                                <Col md={4}>
                                                    <Form.Label>Blocking Price</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control  type='text' name="form.reservation_price" value={form.reservation_price} onChange={e=> handleInput('reservation_price',e.target.value)} isInvalid={!! errors.reservation_price}  />
                                                {errors.reservation_price ? 
                                                    <Form.Control.Feedback type='invalid' className='d-block'>
                                                        { errors.reservation_price }
                                                    </Form.Control.Feedback> : ''}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                            </fieldset>
                            <fieldset className="border p-2 fieldsetCls">
                                <legend className="w-auto">Customer Details</legend>
                                    <Row>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Customer Name</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='text' name="customer_name" value={form.customer_name} onChange={e=> handleInput('customer_name',e.target.value)} isInvalid={!! errors.customer_name} />
                                                <Form.Control.Feedback type='invalid'>
                                                    { errors.customer_name }
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Mobile</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='text' name="mobile" value={form.mobile} onChange={e=> handleInput('mobile',e.target.value)} isInvalid={!! errors.mobile} />
                                                <Form.Control.Feedback type='invalid'>
                                                    { errors.mobile }
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                        <Row>
                                                <Col md={4}>
                                                    <Form.Label>Email</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='email' name="email" value={form.email} onChange={e=> handleInput('email',e.target.value)} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <label>Share Promotions in WhatsApp</label>
                                                </Col>
                                                <Col md={7}>
                                                <CustomSwitch handleChange={handleCheckBox} name = 'whatsapp_share' value={form.whatsapp_share} />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                            </fieldset>
                            <fieldset className="border p-2 fieldsetCls">
                                <legend className="w-auto">Address</legend>
                                    <Row>
                                        <Col md={6}>
                                        <Row>
                                            <Col md={4}>
                                                <label>Address Line 1</label>
                                            </Col>
                                            <Col md={7}>
                                            <Form.Control as='textarea' rows="2" cols="50" name="address_line_1" value={form.address_line_1} onChange={e=> handleInput('address_line_1',e.target.value)} isInvalid={!! errors.address_line_1} />
                                            <Form.Control.Feedback type='invalid'>
                                                { errors.address_line_1 }
                                            </Form.Control.Feedback>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={4}>
                                                <label>Address Line 2</label>
                                            </Col>
                                            <Col md={7}>
                                            <textarea rows="2" cols="50" name="address_line_2" value={form.address_line_2} onChange={e=> handleInput('address_line_2',e.target.value)}>{form.address_line_2}</textarea>
                                            </Col>
                                        </Row>
                                        </Col>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Area</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Select className={`selectBox ${!! errors.area ? 'inValidField' : ''}`}
                                                        value={area}
                                                        onChange={e=>handleSelect('area',setarea,e)}
                                                        options={areaList}
                                                        isClearable 
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>State</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                    <Select className={`selectBox ${!! errors.state_id ? 'inValidField' : ''}`}
                                                        value={state}
                                                        onChange={e=>handleSelect('state_id',setstate,e)}
                                                        options={stateList}
                                                        isClearable 
                                                    />
                                                    {errors.state_id ? 
                                                    <Form.Control.Feedback type='invalid' className='d-block'>
                                                        { errors.state_id }
                                                    </Form.Control.Feedback> : ''}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Pincode</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='text' name="pincode" value={form.pincode} onChange={e=> handleInput('pincode',e.target.value)}  isInvalid={!! errors.pincode} />
                                                <Form.Control.Feedback type='invalid'>
                                                    { errors.pincode }
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                            </fieldset>
                            <Row>
                                                <Col md={12} className='unlock'>
                                                <CustomSwitch handleChange={handleCheckBox} name = 'unlock_special_discount' value={form.unlock_special_discount} className='switch' />
                                                <div className='text'> Are you interested to unlock special discounts upto Rs.50000, if yes our Kalyan representative will contact you</div>
                                                </Col>
                                            </Row>

                            {/* <fieldset className="border p-2 fieldsetCls">
                                <legend className="w-auto">Bride & Groom Details</legend>
                                    <Row>
                                        <Col md={6}>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Customer Relationship</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='text' name="customer_relationship" value={form.customer_relationship} onChange={e=> handleInput('customer_relationship',e.target.value)} isInvalid={!! errors.customer_relationship} />
                                                <Form.Control.Feedback type='invalid'>
                                                    { errors.customer_relationship }
                                                </Form.Control.Feedback>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Bride Name</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='text' name="bride_name" value={form.bride_name} onChange={e=> handleInput('bride_name',e.target.value)} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Bride Mobile</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='text' name="bride_mobile" value={form.bride_mobile} onChange={e=> handleInput('bride_mobile',e.target.value)} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Bride Email</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='email' name="bride_email" value={form.bride_email} onChange={e=> handleInput('bride_email',e.target.value)} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <label>Active</label>
                                                </Col>
                                                <Col md={7}>
                                                <CustomSwitch handleChange={handleCheckBox} name = 'active' value={form.active} />
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={6}>
                                        <Row>
                                                <Col md={4}>
                                                    <Form.Label>Groom Name</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='text' name="groom_name" value={form.groom_name} onChange={e=> handleInput('groom_name',e.target.value)} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Groom Mobile</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='text' name="groom_mobile" value={form.groom_mobile} onChange={e=> handleInput('groom_mobile',e.target.value)} />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={4}>
                                                    <Form.Label>Groom Email</Form.Label>
                                                </Col>
                                                <Col md={7}>
                                                <Form.Control type='email' name="groom_email" value={form.groom_email} onChange={e=> handleInput('groom_email',e.target.value)} />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                            </fieldset> */}
                        </Col></Row>
                        : ''}
                    </Loader>
                    </Form>
                </div>
            </Col>
        </Row>
        <Modal toggle={e=>{toggleModal()}} isOpen={showModal} className='otpModal' >
          <ModalHeader
            toggle={e=>{toggleModal()}}
          >
            Verify OTP
          </ModalHeader>
          <ModalBody>
              <div className='otpCont'>
                <OTPInput value={OTP} onChange={setOTP} autoFocus OTPLength={6} otpType="number" secure />
                <ResendOTP className="otpResend" renderButton={renderButton} renderTime={renderTime} onResendClick={() => genOTP} />              </div>         
         </ModalBody>
         <ModalFooter>
            <Button variant='primary' disabled={empty(OTP)} onClick={e=>{verifyOTP()}}>Verify</Button> 
         </ModalFooter>
        </Modal>
        <Modal toggle={e=>{handleModalClose()}} isOpen={showPayModal} className='otpModal' >
          <ModalHeader
            toggle={e=>{handleModalClose()}}
          >
           Payment Details
          </ModalHeader>
          <ModalBody>
              <div className='theme-light'>
                <Form className="form defaultForm" >
                    <Row>
                        <Col md={12}>
                        <Row>
                            <Col md={4}>
                                <Form.Label>Mobile</Form.Label>
                            </Col>
                            <Col md={7}>
                            <Form.Control type='number' name="mobile" value={payDetails.mobile} onChange={e=> handlePayInput('mobile',e.target.value)} isInvalid={!! payErrors.mobile} />
                            <Form.Control.Feedback type='invalid'>
                                { payErrors.mobile }
                            </Form.Control.Feedback>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <Form.Label>Email</Form.Label>
                            </Col>
                            <Col md={7}>
                            <Form.Control type='email' name="email" value={payDetails.email} onChange={e=> handlePayInput('email',e.target.value)} />
                            </Col>
                        </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Label>Amount</Form.Label>
                                </Col>
                                <Col md={7}>
                                <Form.Control type='number' value={payDetails.amountToPay} onChange={e=> handlePayInput('amountToPay',e.target.value)} isInvalid={!! payErrors.amountToPay} />
                                <Form.Control.Feedback type='invalid'>
                                    { payErrors.amountToPay }
                                </Form.Control.Feedback>
                                </Col>
                            </Row>
                            {/* <Row>
                                <Col md={4}>
                                    <label>Alternate Mobile</label>
                                </Col>
                                <Col md={7}>
                                <CustomSwitch handleChange={e=>handlePayCheckBox} name = 'alternate_mobile' value={payDetails.alternate_mobile} />
                                </Col>
                            </Row> */}
                        </Col>
                    </Row>
                </Form>
              </div>
         </ModalBody>
         <ModalFooter>
            <Button variant='primary' onClick={e=>{proceedToPayment()}}>Proceed</Button> 
         </ModalFooter>
        </Modal>
        <Row>
            <Col md={12} style={{textAlign:'center'}}>
                <Button variant='primary'  onClick={e=>{saveForm()}}>Save</Button> 
                <Button variant='secondary' onClick={e=>{renderListView()}}>Cancel</Button>
            </Col>
        </Row>
        {handleErr ? <ErrorHandling title='booking' closeErrorHandling={closeErrorHandling} error={errData} /> : ''}
      </CardBody>
    </Card>
  </Col>
  </Row>
  <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        />
        <div id="result" className="mt-3"></div>
  </Container>
);
};

export default BookingForm;
